import { render, staticRenderFns } from "./editFinancialReceivable.vue?vue&type=template&id=15e95936&scoped=true"
import script from "./editFinancialReceivable.vue?vue&type=script&lang=js"
export * from "./editFinancialReceivable.vue?vue&type=script&lang=js"
import style0 from "./editFinancialReceivable.vue?vue&type=style&index=0&id=15e95936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e95936",
  null
  
)

export default component.exports